(() => {
  "use strict";

  if (window.theme?.bikeStockStatusInitialized) return;
  window.theme = window.theme || {};
  window.theme.bikeStockStatusInitialized = true;

  const STATUS_SELECTOR = "[data-bike-stock-status]";
  const SELECTED_VARIANT_SELECTOR = "variant-selects [data-selected-variant]";
  const VISIBLE_STATUSES = new Set(["store", "supplier", "out"]);
  const STATUS_CLASSES = ["count-is-in", "count-is-low", "count-is-out", "count-is-unavailable"];
  const COUNTDOWN_STATUS = {
    store: {
      className: "count-is-in",
      selector: ".variant__countdown--in",
    },
    supplier: {
      className: "count-is-low",
      selector: ".variant__countdown--low",
    },
    out: {
      className: "count-is-out",
      selector: ".variant__countdown--out",
    },
  };
  const FALLBACK_LABELS = {
    out: "Sluts\u00e5ld",
  };
  const requestCounters = new WeakMap();
  const deliveryTimers = new WeakMap();
  const latestStock = new WeakMap();

  function clearDelivery(productInfo) {
    const delivery = productInfo.querySelector('[data-bcf-delivery]');
    if (!delivery) return;
    clearTimeout(deliveryTimers.get(productInfo));
    delivery.hidden = true;
    const statusElement = productInfo.querySelector(STATUS_SELECTOR);
    if (statusElement?.dataset.bcfDeliveryStatus) {
      if (!statusElement.hasAttribute('data-clean-supplier-status')) setStatus(statusElement, statusElement.dataset.bcfDeliveryStatus === 'available'
        ? { status: 'supplier', label: delivery.dataset.supplier }
        : { status: 'out', label: delivery.dataset.out });
      delete statusElement.dataset.bcfDeliveryStatus;
    }
    delivery.querySelectorAll('span').forEach(element => { element.textContent = ''; });
    productInfo.querySelectorAll('[data-bcf-static-delivery]').forEach(element => {
      element.textContent = delivery.dataset.fallback;
    });
  }

  function updateDelivery(productInfo, stock) {
    clearDelivery(productInfo);
    const delivery = productInfo.querySelector('[data-bcf-delivery]');
    const helper = window.theme?.bcfDelivery;
    if (!delivery || !helper) return;
    let context;
    try {
      context = JSON.parse(productInfo.querySelector('[data-bcf-delivery-json]')?.textContent || 'null');
    } catch { return; }
    const selected = parseSelectedVariant(productInfo);
    const selectedId = selected?.id || productInfo.querySelector(STATUS_SELECTOR)?.dataset.bikeStockVariantId;
    if (String(context?.variantId) !== String(selectedId) ||
        String(stock?.variantId).replace('gid://shopify/ProductVariant/', '') !== String(selectedId)) return;

    const statusElement = productInfo.querySelector(STATUS_SELECTOR);
    const store = helper.locationQuantity(stock, '107926126918');
    const supplier = helper.locationQuantity(stock, '117426028870');
    if (store > 0) {
      setStatus(statusElement, { status: 'store', label: delivery.dataset.store });
      productInfo.querySelectorAll('[data-bcf-static-delivery]').forEach(element => {
        element.textContent = element.dataset.bcfStoreText;
      });
      return;
    }
    if (store !== null && supplier !== null) {
      setStatus(statusElement, supplier > 0
        ? { status: 'supplier', label: delivery.dataset.supplier }
        : { status: 'out', label: delivery.dataset.out });
    }
    const result = helper.evaluate(context, stock);
    if (!result) return;
    const format = value => new Intl.DateTimeFormat(delivery.dataset.locale || 'sv', {
      day: 'numeric', month: 'long', year: 'numeric', timeZone: 'UTC',
    }).format(helper.calendarDate(value));
    const estimate = result.status === 'available' ? delivery.dataset.available
      : delivery.dataset.expected.replace('__FROM__', format(result.from)).replace('__TO__', format(result.to));
    setStatus(statusElement, { status: result.status === 'available' ? 'supplier' : 'out', label: estimate });
    statusElement.dataset.bcfDeliveryStatus = result.status;
    delivery.querySelector('[data-bcf-delivery-dispatch]').textContent = result.dispatch
      ? delivery.dataset.dispatch.replace('__DATE__', format(result.dispatch)) : '';
    delivery.querySelector('[data-bcf-delivery-preliminary]').textContent = result.dispatch ? delivery.dataset.preliminary : '';
    delivery.querySelectorAll('br').forEach((element, index) => { element.hidden = index === 0 || !result.dispatch; });
    delivery.hidden = result.status === 'available';
    const remaining = helper.maxAge - (Date.now() - Date.parse(context.delivery.checked_at)) + 1;
    const clock = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Stockholm', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' }).formatToParts(new Date());
    const part = type => Number(clock.find(value => value.type === type).value);
    const untilMidnight = ((24 - part('hour')) * 3600 - part('minute') * 60 - part('second')) * 1000 - new Date().getMilliseconds() + 1;
    deliveryTimers.set(productInfo, setTimeout(() => {
      if (productInfo.isConnected) updateDelivery(productInfo, latestStock.get(productInfo));
    }, Math.min(remaining, untilMidnight)));
  }

  function parseSelectedVariant(productInfo) {
    const script = productInfo.querySelector(SELECTED_VARIANT_SELECTOR);

    if (!script?.textContent) {
      return null;
    }

    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      console.warn("[Bike stock status] Failed to parse selected variant", error);
      return null;
    }
  }

  function setStatus(statusElement, payload) {
    if (statusElement?.hasAttribute('data-clean-supplier-status')) {
      const valid = payload && VISIBLE_STATUSES.has(payload.status) && payload.label;
      const status = valid ? payload.status : null;
      const selector = valid ? COUNTDOWN_STATUS[status].selector : '.variant__countdown--unavailable';
      const text = valid ? payload.label : statusElement.dataset.stockFallback;
      statusElement.querySelectorAll('span:not(.variant__countdown--preorder)').forEach(element => {
        element.textContent = element.matches(selector) ? text : '';
      });
      statusElement.classList.remove(...STATUS_CLASSES);
      statusElement.classList.add(valid ? COUNTDOWN_STATUS[status].className : 'count-is-unavailable');
      if (valid) statusElement.dataset.bikeStockState = status;
      else statusElement.removeAttribute('data-bike-stock-state');
      statusElement.dataset.bikeStockReady = valid ? 'true' : 'false';
      return;
    }
    const statusLabel = payload ? payload.label || FALLBACK_LABELS[payload.status] : "";
    const shouldShow = payload && VISIBLE_STATUSES.has(payload.status) && statusLabel;

    if (!shouldShow) {
      statusElement.removeAttribute("data-bike-stock-state");
      statusElement.dataset.bikeStockReady = "true";
      return;
    }

    const countdownStatus = COUNTDOWN_STATUS[payload.status];
    const label = countdownStatus ? statusElement.querySelector(countdownStatus.selector) : null;

    if (!countdownStatus || !label) {
      statusElement.dataset.bikeStockReady = "true";
      return;
    }

    statusElement.classList.remove(...STATUS_CLASSES);
    statusElement.classList.add(countdownStatus.className);
    statusElement.dataset.bikeStockState = payload.status;
    statusElement.dataset.bikeStockReady = "true";
    if (label) label.textContent = statusLabel;
  }

  async function updateProductInfo(productInfo) {
    const statusElement = productInfo.querySelector(STATUS_SELECTOR);

    if (!statusElement) {
      return;
    }

    const selectedVariant = parseSelectedVariant(productInfo);
    const variantId = selectedVariant?.id || statusElement.dataset.bikeStockVariantId;
    const endpoint = statusElement.dataset.bikeStockEndpoint || "/apps/bike-stock-status";

    if (!variantId) {
      setStatus(statusElement, null);
      return;
    }

    statusElement.dataset.bikeStockVariantId = String(variantId);

    const requestId = (requestCounters.get(statusElement) || 0) + 1;
    requestCounters.set(statusElement, requestId);
    clearDelivery(productInfo);
    if (statusElement.hasAttribute('data-clean-supplier-status')) setStatus(statusElement, null);

    const apply = payload => {
      if (requestCounters.get(statusElement) !== requestId || !statusElement.isConnected ||
          productInfo.querySelector(STATUS_SELECTOR) !== statusElement) return;
      if (productInfo.querySelector('[data-bcf-delivery]')) {
        statusElement.dataset.bikeStockReady = 'true';
        latestStock.set(productInfo, payload);
        updateDelivery(productInfo, payload);
      } else {
        setStatus(statusElement, payload);
      }
    };

    try {
      const url = new URL(endpoint, window.location.origin);
      url.searchParams.set("variant_id", variantId);

      const response = await fetch(url.toString(), {
        headers: { Accept: "application/json" },
      });

      if (!response.ok) {
        apply(null);
        return;
      }

      const payload = await response.json();

      if (requestCounters.get(statusElement) !== requestId) {
        return;
      }

      apply(payload);
    } catch (error) {
      console.warn("[Bike stock status] Failed to load status", error);
      apply(null);
    }
  }

  function updateAll(root = document) {
    if (root.matches?.('product-info')) updateProductInfo(root);
    root.querySelectorAll("product-info").forEach(updateProductInfo);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => updateAll());
  } else {
    updateAll();
  }

  document.addEventListener("theme:product-info:loaded", (event) => {
    const root = event.target instanceof Element ? event.target : document;
    updateAll(root);
  });
  document.addEventListener('shopify:section:load', event => updateAll(event.target));
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) updateAll();
  });
  document.addEventListener('change', event => {
    const productInfo = event.target.closest?.('product-info');
    if (!productInfo || !event.target.closest('variant-selects')) return;
    const status = productInfo.querySelector(STATUS_SELECTOR);
    if (status) requestCounters.set(status, (requestCounters.get(status) || 0) + 1);
    clearDelivery(productInfo);
    if (status?.hasAttribute('data-clean-supplier-status')) setStatus(status, null);
  }, true);

  if (window.subscribe && window.theme?.PUB_SUB_EVENTS?.variantChange) {
    window.subscribe(window.theme.PUB_SUB_EVENTS.variantChange, (event) => {
      const sectionId = event?.data?.sectionId;
      const productInfo = sectionId
        ? Array.from(document.querySelectorAll("product-info")).find((element) => element.dataset.section === sectionId)
        : null;

      if (productInfo) {
        updateProductInfo(productInfo);
      } else {
        updateAll();
      }
    });
  }
})();
